/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { Form } from "react-final-form";
import BasicInvoiceDetailsForm from "./basicDetails";
import ProductDetails from "./productDetails";
import BankDetailsForm from "./bankDetails";
import FinalTotalForm from "./finalTotal";
import useInvoiceHook from "../useInvoice";
import { ToastContainer } from "react-toastify";
import alertify from "alertifyjs";

const AddInvoiceForm = ({ isEdit, id, data }) => {
  const [menu, setMenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const { FetchInvoiceStatus } = useInvoiceHook();
  const { status } = FetchInvoiceStatus();
  const invoice = window.INVOICE;
  useEffect(() => {
    let elements = Array.from(
      document.getElementsByClassName("react-datepicker-wrapper")
    );
    elements.map((element) => element.classList.add("w-100"));
  }, []);

  const getSeletedCustomer = (value) => {
    if (!value) return null;
    return {
      value: value.id,
      label: value?.user?.full_name,
      data: value,
    };
  };

  const initialValues = isEdit
    ? {
        ...data,
        customer: getSeletedCustomer(data?.customer),
      }
    : {};

  function transformInvoicePayload(data) {
    return {
      invoice_number: data.invoice_number || "",
      reference_number: data.reference_number || "",
      customer_id: data.customer?.value || null,
      invoice_date: data.invoice_date || data.invoiceDate,
      status: data.status?.value || 2,
      discount_value: data.discount_value || 0,
      tax: data.tax || 0,
      notes: data.notes || "",
      terms: data.terms || "",
      signature_name: data.signature_name || invoice?.digital_signature_name,
      signature_image: data.signature_image || invoice?.digital_signature_image,
      airway_number: data.airway_number || "",
      qr_link_url: data.qr_link_url || "",
      invoice_products: (data.invoice_products || []).map((item) => ({
        product: item.product || null,
        quantity: item.quantity || 0,
        unit: item.unit || "",
        rate: item.rate || 0,
        discount: item.discount || 0,
      })),
    };
  } 

  const onSubmit = (values) => {
    if (!values?.invoice_products || values?.invoice_products?.length === 0) {
    alertify.error(
            "Please add at least one product."
          );
      return;
    }
    
    // Check if all required fields have values for each product
    const hasEmptyFields = values.invoice_products.some(item => 
      !item.product || 
      !item.quantity || 
      !item.unit || 
      !item.rate
    );
    
    if (hasEmptyFields) {
      alertify.error(
        "Please fill all required fields for each product."
      );
      return;
    }
    setLoading(true);
    const transformedValues = transformInvoicePayload(values);
    fetch(
      isEdit ? `/invoice/${data?.id}/edit-update/` : "/invoice/add-invoice/",
      {
        method: isEdit ? "PUT" : "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": document.cookie
            .split("; ")
            .find((row) => row.startsWith("csrftoken="))
            ?.split("=")[1],
        },
        credentials: "include",
        body: JSON.stringify(transformedValues),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (!data) return;
        if (data && data.success) {
          if (data?.data?.id) {
            window.location.href = `/invoice/${data?.data?.id}/invoice`;
          }
          console.log(data);
          setLoading(false);
        } else {
          console.log("error:", data);
          if (data.errors) {
            // Handle field-specific errors
            Object.keys(data.errors).forEach(field => {
              const fieldErrors = data.errors[field];
              if (Array.isArray(fieldErrors)) {
                fieldErrors.forEach((error, index) => {
                  if (typeof error === 'object' && error !== null) {
                    Object.keys(error).forEach(subField => {
                      const subFieldError = error[subField];
                      if (Array.isArray(subFieldError)) {
                        subFieldError.forEach(subError => {
                          alertify.error(`${field} ${index + 1} - ${subField}: ${subError}`);
                        });
                      } else {
                        alertify.error(`${field} ${index + 1} - ${subField}: ${subFieldError}`);
                      }
                    });
                  } else {
                    alertify.error(`${field} ${index + 1}: ${error}`);
                  }
                });
              } else {
                alertify.error(`${field}: ${fieldErrors}`);
              }
            });
          } else if (data.message) {
            alertify.error(data.message);
          } else {
            alertify.error("An error occurred while saving the invoice.");
          }
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error adding invoice:", error);
      });
  };
  const memoizedInitialValues = useMemo(() => {
    return {
      ...initialValues,
      invoice_date: initialValues?.invoice_date
        ? new Date(initialValues?.invoice_date)
        : new Date(),
      signature_name:
        initialValues.signature_name || invoice?.digital_signature_name,
      signature_image:
        initialValues.signature_image || invoice?.digital_signature_image,
      terms: initialValues.terms || invoice?.invoice_terms_conditions,
    };
  }, [data, isEdit]); // only rebuild when edit/data changes
  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <div className="page-wrapper">
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <div className="content container-fluid">
          <div className="card mb-0">
            <div className="card-body">
              <div className="page-header">
                <div className="content-page-header">
                  <h5>
                    {isEdit
                      ? `Edit Invoice #${data?.invoice_number}`
                      : "Add Invoice"}
                  </h5>
                </div>
              </div>
              <Form
                onSubmit={onSubmit}
                initialValues={memoizedInitialValues}
                keepDirtyOnReinitialize
                render={({
                  handleSubmit,
                  form,
                  submitting,
                  pristine,
                  values,
                  valid,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <BasicInvoiceDetailsForm
                      status={status?.status_choices || []}
                    />
                    <hr />
                    <ProductDetails />
                    <div className="form-group-item border-0 p-0">
                      <div className="row">
                        <BankDetailsForm />
                        <FinalTotalForm />
                      </div>
                    </div>
                    <div className="add-customer-btns text-end">
                      <button
                        type="button"
                        className="btn btn-primary cancel me-2"
                        onClick={() => window.history.back()}
                        disabled={submitting}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary cancel me-2"
                        onClick={form.submit}
                        disabled={submitting || loading || !valid}
                      >
                        Save
                        {loading && (
                          <span
                            className="spinner-border spinner-border-sm ms-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        )}
                      </button>
                      {/* <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={submitting}
                      >
                        Save &amp; Send
                      </button> */}
                    </div>
                  </form>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddInvoiceForm;
